// extracted by mini-css-extract-plugin
export default {"slider":"_1WV3h","slider-short":"Bv_30","sliderShort":"Bv_30","slider-adoptables":"_35Cdu","sliderAdoptables":"_35Cdu","slider-item":"_2m7Oz","sliderItem":"_2m7Oz"};